import styled from 'styled-components';

export const Container = styled.div`
  border-top: 1px solid var(--color-grey6A);
  margin-top: 10px;
  padding-top: 10px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding-right: 5px;
  cursor: pointer;
`;

export const Label = styled.label`
  width: 240px;
  text-align: left;
  color: var(--color-grey6A);
  font-weight: var(--font-weight600);
  font-size: var(--font-size15);
  line-height: 1.2;
  letter-spacing: 0;
  padding-right: 10px;
`;

export const ItemContent = styled.div`
  margin: 0;
  padding: 30px 0;
`;
